import { render, staticRenderFns } from "./sectionAdmin.vue?vue&type=template&id=159fd89c&scoped=true&"
import script from "./sectionAdmin.vue?vue&type=script&lang=js&"
export * from "./sectionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./sectionAdmin.vue?vue&type=style&index=0&id=159fd89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159fd89c",
  null
  
)

export default component.exports